import LocalizedStrings from 'react-localization';
import { strings as en } from './en/all';

let lang_strings = new LocalizedStrings({
  en,
});

export const strings = lang_strings;
